import axios from 'axios'
import { StoryClient } from './storyClient'
import { CollectionClient } from './collectionClient'
import { ExhibitClient } from './exhibitClient'
import { OrganizationClient } from './organizationClient'
import { MapStyleClient } from './mapStyleClient'
import Rank from './rank'
import TosClient from './tosClient'
import Util from './util'
import UgcClient from './ugcClient'
import ImageClient from './imageClient'
import request from './request'

export { default as ugcSaveValidator } from './validators/ugcSaveValidator'
export { default as ugcUploadValidator } from './validators/ugcUploadValidator'
export { default as presignValidator } from './validators/presignValidator'

export class ExhibitionClient {
  constructor({ url, proxyUrl, _axios}) {
    if(url) {
      this.url = url
    }else{
      this.url = 'https://create.passitdown.com'
    }

    this.axios = _axios || axios

    const { _get, _post, _put }  = new request({_axios: this.axios})

    const params = {url: this.url, proxyUrl, _axios: this.axios, _get, _post, _put}
    this.storyClient = new StoryClient(params)
    this.collectionClient = new CollectionClient(params)
    this.exhibitClient = new ExhibitClient(params)
    this.organizationClient = new OrganizationClient(params)
    this.mapStyleClient = new MapStyleClient(params)
    this.tosClient = new TosClient(params)
    this.ugcClient = new UgcClient(params)
    this.imageClient = new ImageClient(params)
  }

  collection() {
    return this.collectionClient
  }

  exhibit() {
    return this.exhibitClient
  }

  mapStyle() {
    return this.mapStyleClient
  }

  image() {
    return this.imageClient
  }

  organization() {
    return this.organizationClient
  }

  rank() {
    return Rank
  }

  story() {
    return this.storyClient
  }

  tos() {
    return this.tosClient
  }

  ugc() {
    return this.ugcClient
  }

  util() {
    return Util
  }
}
